module.exports = __webpack_public_path__ + "img/kz.f0a24c9d.png";